import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { FlameIcon } from './Icons';
export function FinalCTA() {
  return <section className="bg-olive text-cream py-24 px-4 relative overflow-hidden" data-id="element-57">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom,rgba(197,165,90,0.2),transparent_70%)]" data-id="element-58" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-60">
          <FlameIcon className="w-12 h-12 text-gold mx-auto mb-8" data-id="element-61" />
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-12" data-id="element-62">
            SÍ, QUIERO CAMINAR CON JESÚS DE VERDAD
          </h2>

          <div className="mb-12" data-id="element-63">
            <CTAButton className="w-full md:w-auto text-xl py-5 px-10" href="https://coresolutionsg.com/cart/47581083304123:1" data-id="element-64" />
            <div className="mt-6 flex flex-wrap justify-center gap-4 text-sm text-cream/70 font-bold uppercase tracking-wider" data-id="element-65">
              <span data-id="element-66">· Acceso Inmediato por Solo $9.87</span>
              <span className="hidden md:inline" data-id="element-67">·</span>
              <span data-id="element-68">Pago Único</span>
              <span className="hidden md:inline" data-id="element-69">·</span>
              <span data-id="element-70">Garantía de 7 días</span>
              <span className="hidden md:inline" data-id="element-71">·</span>
              <span data-id="element-72">Acceso permanente</span>
            </div>
          </div>

          <div className="bg-dark/20 p-8 rounded-xl border border-white/10 text-left" data-id="element-73">
            <p className="text-gold font-bold uppercase tracking-wider text-sm mb-4" data-id="element-74">
              Una última palabra antes de decidir:
            </p>
            <p className="font-serif italic text-xl md:text-2xl leading-relaxed text-cream/90" data-id="element-75">
              "No necesitas ser diferente para comenzar. No necesitas más fe,
              más disciplina ni más conocimiento teológico. Solo necesitas
              presentarte. Él hace el resto desde ahí. Siempre lo ha hecho.
              Siempre lo hará."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}